<template>
    <div>
        <link rel="stylesheet" href="/modules/pk_productscarousel/css/productscarousel.css" type="text/css" media="all">
        <div class="title-bg"><h3>{{ translations['Cross Selling'] }}</h3></div>
        <div class="productsCarousel">
            <div style="position: relative; " class="accordionContent tab-content activeCarousel" id="bes" data-acc="3">
                <ul id="bes-products" class="da-thumbs slides" style="display: none;">
                    <li v-for="crossSellingProduct in crossSellingProducts" class="block_product ajax_block_product slide" style="padding-right: 15px;">
                        <item :crossSellingProduct="crossSellingProduct"/>
                    </li>
                </ul>
                <div id="bes-customize-controls-prev" class="prev customize-controls customize-controls-prev" aria-controls="customize" tabindex="-1" data-controls="prev">
                    <div class="chevron-arrow-left"></div>
                </div>
                <div id="bes-customize-controls-next" class="next customize-controls customize-controls-next" aria-controls="customize" tabindex="-1" data-controls="next">
                    <div class="chevron-arrow-right"></div>
                </div>
                <div class="clearfix"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import './../../../../../node_modules/tiny-slider/src/tiny-slider.scss';
    import { tns } from './../../../../../node_modules/tiny-slider/src/tiny-slider';
    import Item from "./Item";

    export default {
        name: 'CrossSelling',
        components: {Item},
        computed: {
            ...mapState({
                translations: state => state.translations,
                crossSellingProducts: state => state.crossSellingProducts,
            }),
        },
        mounted () {
            tns({
                "container": "#bes-products",
                "items": 2,
                "edgePadding": 20,
                "swipeAngle": false,
                "speed": 400,
                "nav": false,
                "prevButton": "#bes-customize-controls-prev",
                "nextButton": "#bes-customize-controls-next",
                "lazyload": true,
                "responsive": {
                    "400": {
                        "items": 3
                    },
                    "768": {
                        "items": 5.5
                    }
                },
                'onInit': function () {
                    setTimeout(function () {
                        var elements = document.getElementsByClassName('accordionContent');
                        for (var i = 0; i < elements.length; i++) {
                            var element = elements[i];
                            element.classList.add('no-before');
                            element.style.height = 'auto';
                            element.style.background = '#ffffff';
                            element.style.paddingTop = '0px';
                            var uls = element.querySelectorAll('ul');
                            for (var j = 0; j < uls.length; j++) {
                                var ul = uls[j];
                                ul.style.visibility = 'visible';
                                ul.style.display = 'block';
                            }
                        }
                    }, 500)
                }
            });
        },
    }
</script>
<style scoped="scoped" lang="scss">
    @import "./../../scss/main";

    @include mobile {
        .productsCarousel {
            margin-bottom: 0;
        }
    }

</style>